import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const printPDF = {
  printPDFButton: document.getElementById("printPDF"),
  pdfContent: document.getElementById("pdfContent"),
  icon: document.getElementById("printPDFIcon"),
  loader: document.getElementById("printPDFLoader"),
  isLoading: false,

  init() {
    this.setprintPDF();
  },

  setprintPDF() {
    if (this.printPDFButton) {
      this.printPDFButton.addEventListener("click", async () => {
        if (!this.pdfContent || this.isLoading) return;
        this.isLoading = true;
        this.loader?.classList.remove('d-none');
        this.icon?.classList.add('d-none');
        
        const pdfWidth = 368;
        const pdfHeight = 520;
        const padding = 10; 
        const scaleFactor = 2;

        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "px",
          format: [pdfWidth, pdfHeight],
        });

        const pages = this.pdfContent.querySelectorAll(".jsPage") as NodeListOf<HTMLElement>;

        for (let i = 0; i < pages.length; i++) {
          const page = pages[i];

          // Capture each page as canvas
          const canvas = await html2canvas(page, {
            scrollX: 0,
            scrollY: 0,
            windowWidth: page.scrollWidth,
            windowHeight: page.scrollHeight,
          });

          const imgWidth = canvas.width / scaleFactor;
          const imgHeight = canvas.height / scaleFactor;
          const imgData = canvas.toDataURL("image/png");

          let remainingHeight = imgHeight;

          // Handle multiple pages if the content is larger than a single page
          while (remainingHeight > 0) {
            if (i > 0 || (i === 0 && remainingHeight < imgHeight)) {
              pdf.addPage([pdfWidth, pdfHeight]);
            }

            const sliceHeight = Math.min(remainingHeight, pdfHeight - 2 * padding); // Height for the current PDF page
            
            pdf.addImage(
              imgData,
              "PNG",
              padding,
              padding,
              pdfWidth - 2 * padding, // Image width
              sliceHeight // Image height for this slice
            );

            remainingHeight -= sliceHeight;
          }
        }

        const title = this.pdfContent.dataset.title + ".pdf";
        pdf.save(title);

        this.loader?.classList.add('d-none');
        this.icon?.classList.remove('d-none');
        this.isLoading = false;
      });
    }
  },
};

export default printPDF;
